import { z } from 'zod';

export const CompanyRestrictionsFlagValues = [
  'block_affiliate_fronts',
  'block_collective_operations',
  'block_voluntary_payments',
  'block_withdrawals',
  'block_arbitrages',
  'block_incoming_transfers',
] as const;
export const ZodCompanyRestrictionsFlag = z.enum(CompanyRestrictionsFlagValues);

export type CompanyRestrictionsFlag = z.TypeOf<typeof ZodCompanyRestrictionsFlag>;
